import * as Yup from 'yup';

export const createFeedback360ValidationSchema = (t: any, isFirstSubmit: boolean) => {
  return Yup.object({
    contacts: Yup.array()
      .of(
        Yup.object({
          email: Yup.string()
            .email(`${t("assessments.feedback360.email-validation")}`)
            .required(`${t("assessments.feedback360.email-required")}`),
          type: Yup.string().required(
            `${t("assessments.feedback360.select-validation")}`
          ),
          // Don't validate disabled as it's optional
          disabled: Yup.boolean(),
        })
      )
      .test(
        "min-valid-contacts",
        isFirstSubmit 
          ? "Please fill out at least 8 contacts" 
          : "Please add at least 1 new contact",
        (contacts) => {
          if (!contacts) return false;
          
          if (isFirstSubmit) {
            const validContacts = contacts.filter(
              (contact) => contact.email && contact.type
            );
            return validContacts.length >= 8;
          } else {

            const validNewContacts = contacts.filter(
              (contact) => 
                contact.email && 
                contact.type && 
                contact.disabled !== true 
            );
            return validNewContacts.length >= 1;
          }
        }
      )
      .test(
        "no-duplicate-emails",
        "Duplicate emails are not allowed",
        (contacts) => {
          if (!contacts) return true;
          const emails = contacts
            .filter(contact => contact.email)
            .map(contact => contact.email.toLowerCase().trim());
          const uniqueEmails = new Set(emails);
          return uniqueEmails.size === emails.length;
        }
      ),
    comment: Yup.string(),
  });
};